<script>
    export let userList;
    export let decisions;
    export let round;
    export let isGameOn;
    export let isGameEnd;
    export let userName;
    export let teamColour;
    export let lang = 'pl';
    import { texts, teamColours, polishColours } from './texts.js';
    export let activeMaps = {};
    export let tgVisible = false;
    let myTeam = polishColours[teamColour];

    // $: console.log(userList);
</script>

<div class="aside">
    <div class="stan">
        <div>
            <h4>{texts[lang].you_play_as} {teamColours[lang][myTeam]}</h4>
            <h4>{texts[lang].your_nick} {userName}</h4>
        </div>
        {#if teamColour !== 'trener'}
            <div>
                <button
                    class="anchor_button"
                    on:click={() => {
                        tgVisible = true;
                    }}
                >
                    {texts[lang].your_goal}<i class="fas fa-anchor" /></button
                >
            </div>
        {:else}
            <button class="anchor_button">
                {texts[lang].your_goal}<i class="fas fa-anchor" /></button
            >
        {/if}
    </div>
    <div class="runda">
        <h3>{texts[lang].round}{round}</h3>
        <h3>{texts[lang].active_players}:</h3>
    </div>
    <div class="gracze">
        <div class="orange obecnosc border-left">
            <span class="team-name">{texts[lang].orange_team}</span>
            <ul class="li-obecnosc">
                {#if userList[0]}
                    {#each userList[0].users as player}
                        <div class="li">{player}</div>
                    {/each}
                {/if}
            </ul>
            <div class="orange-stan obecnosc border-right">
                {#if activeMaps.teamA}
                    <i class="fas fa-map" />
                {/if}
                <h3>
                    {#if !isGameOn}
                        {!isGameEnd
                            ? texts[lang].game_inactive
                            : texts[lang].game_ended}
                    {:else}{texts[lang][decisions[userList[0].name]]}{/if}
                </h3>
            </div>
        </div>

        <div class="green obecnosc border-left">
            <span class="team-name">{texts[lang].green_team}</span>
            <ul class="li-obecnosc">
                {#if userList[1]}
                    {#each userList[1].users as player}
                        <div class="li">{player}</div>
                    {/each}
                {/if}
            </ul>
            <div class="green-stan obecnosc border-right">
                {#if activeMaps.teamB}
                    <i class="fas fa-map" />
                {/if}
                <h3>
                    {#if !isGameOn}
                        {!isGameEnd
                            ? texts[lang].game_inactive
                            : texts[lang].game_ended}
                    {:else}{texts[lang][decisions[userList[1].name]]}{/if}
                </h3>
            </div>
        </div>

        <div class="violet obecnosc border-left">
            <span class="team-name">{texts[lang].violet_team}</span>
            <ul class="li-obecnosc">
                {#if userList[2]}
                    {#each userList[2].users as player}
                        <div class="li">{player}</div>
                    {/each}
                {/if}
            </ul>
            <div class="violet-stan obecnosc border-right">
                {#if activeMaps.teamC}
                    <i class="fas fa-map" />
                {/if}
                <h3>
                    {#if !isGameOn}
                        {!isGameEnd
                            ? texts[lang].game_inactive
                            : texts[lang].game_ended}
                    {:else}{texts[lang][decisions[userList[2].name]]}{/if}
                </h3>
            </div>
        </div>

        <div class="blue obecnosc border-left">
            <span class="team-name">{texts[lang].blue_team}</span>
            <ul class="li-obecnosc">
                {#if userList[3]}
                    {#each userList[3].users as player}
                        <div class="li">{player}</div>
                    {/each}
                {/if}
            </ul>
            <div class="blue-stan obecnosc border-right">
                {#if activeMaps.teamD}
                    <i class="fas fa-map" />
                {/if}
                <h3>
                    {#if !isGameOn}
                        {!isGameEnd
                            ? texts[lang].game_inactive
                            : texts[lang].game_ended}
                    {:else}{texts[lang][decisions[userList[3].name]]}{/if}
                </h3>
            </div>
        </div>

        <div class="trener obecnosc border-left">
            <span class="team-name">{texts[lang].trainer_team}</span>
            <ul class="li-obecnosc">
                {#if userList[4]}
                    {#each userList[4].users as player}
                        <div class="li">{player}</div>
                    {/each}
                {/if}
            </ul>
        </div>
        <div class="trener-stan obecnosc border-right" />
    </div>
</div>
